var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"mini-upload"},[_c('van-loading',{attrs:{"type":"spinner","vertical":""}},[_vm._v("处理中")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }